import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";

import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import PaymentMethod from "./../../common/PaymentMethods";

import { useUserRights } from "../../../contexts/UserRightsContext";
import AdjustmentTypes from "../../common/AdjustmentTypes";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
}));



const AgentPayment = (props) => {
  const [agentPayment, setAgentPayment] = useState({
    IdAgent: "",
    Description: "",
    Amount: "",
    Reference: "",
    TransactionType: "A",
    TransactionDate: "",
    PaymentMethod: "",
    IdUser: "",
    PreviousBalance: "",
    NewBalance: "",
    Fee: "",
    Bonus: "",
  });
  const [method, setMethod] = useState(2);
  const [adjustmentType, setAdjustmentType] = useState(1);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [insertTran, setInsertTran] = useState(false);
  const [statistic, setStatistic] = useState();

  const [selectedTransactionType, setSelectedTransactionType] = useState("A");

  const [amount, setAmount] = useState("");
  const [description, setDescription] = useState("");
  const [reference, setReference] = useState("");
  const classes = useStyles();
  const handleDateChange = (date) => {
    // setSelectedDate(date);
  };

  const setIdMethodMem = (IdMethod) => {
    setMethod(IdMethod);
  };
  const setIdPaymentOnMem = (event) => {
    setSelectedTransactionType(event.target.value);
  };
  const setDateOnMem = (event) => {
    agentPayment.TransactionDate = event.target.value;
  };
  const setIdAdjTypeMem = (adjustmentId) => {
    setAdjustmentType(adjustmentId);
  };
  const GetAgentBalance = () => {
    let url =
      process.env.REACT_APP_API2_URL +
      "/Agent/Agent_GetStatistics?idAgent=" +
      props.IdAgent;
    return axios({
      method: "get",
      url: url,
    }).then((response) => {
      setStatistic(response.data);
    });
  };
  useEffect(() => {
    agentPayment.TransactionType = "A";
    GetAgentBalance();
  }, []);

  const confirm = (e) => {
    GetAgentBalance();
    setInsertTran(true);
  };
  const insertPayment = async () => {
    const payload = {
      IdAgent: props.IdAgent,
      Description: description,
      Amount: amount,
      Reference: reference,
      TransactionType: selectedTransactionType,
      TransactionDate: new Date(),
      PaymentMethod: method,
      IdUser: userInfo.userId,
      PreviousBalance: statistic.currentBalance,
      NewBalance: CalculateNewBalance(),
    };

    const response = await axios.post(
      process.env.REACT_APP_API2_URL + "/Agent/InsertAgentTransaction",
      payload
    );

    await props.getAgentStatistics(); // ← refresca stats globales

    setInsertTran(false);
  };

  const CalculateNewBalance = () => {
    let newBalance;
    if (
      selectedTransactionType == "A" ||
      selectedTransactionType == "AA" ||
      selectedTransactionType == "R" ||
      selectedTransactionType == "H"
    ) {
      newBalance =
        parseFloat(statistic.currentBalance) + parseFloat(amount);
    } else {
      newBalance =
        parseFloat(statistic.currentBalance) - parseFloat(amount);
    }
    return newBalance;
  };

  const { data: rights } = useUserRights();
  const hasRights = useCallback(
    (...ids) => ids.some((id) => rights?.includes(id)),
    [rights]
  );

  const renderTransactionType = () => {
    return (
      <FormControl variant="outlined" size="small">
        <InputLabel shrink id="demo-simple-select-placeholder-label-label">
          Transaction Type
        </InputLabel>
        <Select
          labelId="demo-customized-select-label"
          id="demo-customized-select"
          value={selectedTransactionType}
          onChange={setIdPaymentOnMem}
        //   input={<BootstrapInput />}
        >
          <MenuItem value="A" hidden={!hasRights(24)}>
            Adjustment
          </MenuItem>
          <MenuItem value="D" hidden={!hasRights(26)}>
            Disbursement
          </MenuItem>
          <MenuItem value="R" hidden={!hasRights(25)}>
            Receipt
          </MenuItem>
          <MenuItem value="T" hidden={!hasRights(36)}>
            Transfers
          </MenuItem>
        </Select>
      </FormControl>
    );
  };
  return (
    <div className="flex flex-col gap-4 h-max">
      <h3 style={{ textAlign: "center" }}>Payments</h3>
      <form className="w-full">
        <FormControl className="flex flex-col w-full gap-4">
          <div className="web-options">
            <TextField
              size="small"
              variant="outlined"
              label="Amount"
              required
              onChange={(e) => setAmount(e.target.value)}
            />
            <PaymentMethod label="Method" setIdMethodMem={setIdMethodMem} />
          </div>
          <div className="web-options">
            <AdjustmentTypes label="Method" setIdAdjTypeMem={setIdAdjTypeMem} />
            {renderTransactionType()}{" "}
          </div>
          <div className="web-options">
            <TextField
              variant="outlined"
              size="small"
              label="Description"
              onChange={(e) => setDescription(e.target.value)}
            />
            <TextField
              variant="outlined"
              size="small"
              label="Reference"
              onChange={(e) => setReference(e.target.value)}
            />
          </div>
          <div className="web-options">
            {!insertTran ? (
              <Button
                onClick={(e) => {
                  confirm(e);
                }}
                className="w-full"
                variant="contained"
                type="button"
                color="secondary"
              >
                Insert Payment
              </Button>
            ) : undefined}
            {insertTran ? (
              <div className="transaction-confirm">
                <h2> Player Balance: {statistic.currentBalance}</h2>
                <h3> Value: {amount} </h3>
                <h3> New Balance: {CalculateNewBalance()}</h3>
                <Button
                  onClick={insertPayment}
                  variant="outlined"
                  color="success"
                >
                  Commit
                </Button>
                <Button
                  onClick={() => {
                    setInsertTran(false);
                  }}
                  variant="contained"
                  color="secondary"
                >
                  Cancel
                </Button>
              </div>
            ) : undefined}
          </div>
        </FormControl>
      </form>
    </div>
  );
};

export default AgentPayment;
